import { Progress } from 'antd';
import useTranslation from 'next-translate/useTranslation';

export interface StepProgressProps {
  progress?: number;
  steps?: number;
  strokeColor?: string;
}

export function StepProgress({
  progress = 0,
  steps = 10,
  strokeColor = 'primary',
}: StepProgressProps) {
  const { t } = useTranslation('common');

  return (
    <div className="mb-4">
      <div className="text-xs text-gray-700">
        {t('completed_out_of_steps', { progress, steps })}
      </div>
      <Progress
        percent={(100 * progress) / steps}
        showInfo={false}
        strokeColor={strokeColor}
      />
    </div>
  );
}

export default StepProgress;
